import React, { useState } from 'react';

export const CustomCopyElement = ({ variable, index }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleDoubleClick = (value) => {
    setShowTooltip(true);
    navigator.clipboard.writeText(value).catch((err) => {
      console.error('Unable to copy value: ', err);
    });
    setTimeout(() => {
      setShowTooltip(false);
    }, 1500);
  };
  return (
    <div
      className={`tooltip ${showTooltip ? 'visible' : ''}`}
      onClick={() => handleDoubleClick(variable.name)}
    >
      <span
        key={`tooltip ${index}`}
        className="label label-status-default role-item cursor-pointer"
      >
        {variable.label}
      </span>
      <span className="tooltiptext">Variable Copied!</span>
    </div>
  );
};
